import { DownloadLinkConfig, STATE } from '../../models/indexPageVariant';
import { njConfig } from './nj';
import { onConfig } from './on';

export const stateConfigs: { [key in STATE]: DownloadLinkConfig } = {
  nj: njConfig,
  on: onConfig
};
